import { ComponentType, lazy } from 'react'

const INTERVAL_MULPLIER = 2
const MAX_INTERVAL = 2000
const wait = (interval: number) => new Promise((resolve) => setTimeout(resolve, interval))

async function retry(
  fn: Function,
  retriesLeft = 7,
  nextInterval = 100,
): Promise<{ default: ComponentType<React.PropsWithChildren<any>> }> {
  try {
    return await fn()
  } catch (error) {
    await wait(nextInterval)
    if (retriesLeft === 0) {
      throw error
    }
    return await retry(fn, --retriesLeft, Math.min(nextInterval * INTERVAL_MULPLIER, MAX_INTERVAL))
  }
}

export function lazyRetry<T = any>(fn: Function): ComponentType<React.PropsWithChildren<T>> {
  return lazy(() => retry(fn))
}
